var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Training_Icon",
    "data-name": "Training Icon",
    transform: "translate(-17.969 -18.027)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.719 18.777)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2692",
    "data-name": "Group 2692",
    transform: "translate(30.029 36.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M73.52,65.63a3.785,3.785,0,1,0,3.78,3.785A3.787,3.787,0,0,0,73.52,65.63Z",
    transform: "translate(-53.794 -58.18)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M72.068,83.34a2.22,2.22,0,0,1-2.181,0,1.713,1.713,0,0,0-.826-.21,4.185,4.185,0,0,0-4.181,4.176v1.112a.386.386,0,0,0,.382.382H76.688a.383.383,0,0,0,.382-.382V87.306a4.179,4.179,0,0,0-4.181-4.176,1.783,1.783,0,0,0-.826.21Z",
    transform: "translate(-51.254 -67.327)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M102.6,53.347V51.533a1.514,1.514,0,0,0-1.518-1.513H91.163a1.513,1.513,0,0,0-1.513,1.513V57.4a1.513,1.513,0,0,0,1.513,1.513h9.918A1.518,1.518,0,0,0,102.6,57.4V55.585l2.558,2.558v-7.36L102.6,53.342Z",
    transform: "translate(-64.201 -50.02)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M89.736,58.448a.1.1,0,0,0,.1-.1V55.68a.1.1,0,0,0-.1-.1H89.65v2.868h.086Z",
    transform: "translate(-64.201 -52.926)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M112.05,67.309V66.56a.1.1,0,0,0-.105-.1H109.32a.1.1,0,0,0-.1.1v.95h2.1A1.487,1.487,0,0,0,112.05,67.309Z",
    transform: "translate(-74.431 -58.613)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M75.4,76.327H73.949V62.534a2.354,2.354,0,0,1-.735.129h-2.1V76.327h-5.3a17.968,17.968,0,0,0-4.463.573,27.86,27.86,0,0,1-5.3.31,28.265,28.265,0,0,1-5.3-.31,17.747,17.747,0,0,0-4.463-.573h-5.3V59.059a.6.6,0,0,1,.592-.611H60.939V55.58H40.8a2.664,2.664,0,0,0-2.635,2.687v18.06H36.712a.383.383,0,0,0-.382.382v1.737A2.258,2.258,0,0,0,38.588,80.7H73.525a2.261,2.261,0,0,0,2.258-2.253V76.709A.383.383,0,0,0,75.4,76.327ZM57.249,79.344H54.863a.382.382,0,1,1,0-.764h2.386a.382.382,0,1,1,0,.764Z",
    transform: "translate(-36.33 -52.926)",
    fill: "#a5551c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainings);
export default __webpack_public_path__ + "static/media/Trainings.1dcc08c319daf8d9aa7e1296c73debf9.svg";
export { ForwardRef as ReactComponent };